

































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { QInfiniteScroll, QInput, QBtn, scroll } from 'quasar'
import store from 'src/assets/store'
import dateShort from 'src/assets/dateShort'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'

@Component({
  components: {
    PersonAvatar
  }
})
export default class ChatLayout extends Vue {
  dateShort = dateShort
  me = store.state.person
  viewport = store.viewport
  message = ''
  bottom = true

  @Prop()
  readonly chat!: { load: (done: (stop?: boolean) => void) => Promise<void>, send: (message: string) => Promise<void> }

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop({ default: true })
  readonly showTimes!: boolean

  @Prop()
  readonly placeholder!: string | undefined

  @Prop()
  readonly safeArea!: boolean

  @Ref()
  readonly historyLoader!: QInfiniteScroll

  @Ref()
  readonly scrollEnd!: HTMLElement

  @Ref()
  readonly input!: QInput

  @Ref()
  readonly sendButton!: QBtn

  get height () {
    return this.viewport.height ? `${this.viewport.height}px` : '100%'
  }

  @Watch('chat.history', { deep: true })
  received () {
    if (this.bottom) {
      // this.scrollDown()
      this.$nextTick(() => {
        this.scrollDown()
      })
    }
  }

  @Watch('viewport.height')
  scrollTop () {
    const bottom = this.bottom
    window.scrollTo(0, 0)
    window.setTimeout(() => {
      window.scrollTo(0, 0)
      if (bottom) {
        this.scrollDown()
      }
    }, 10);
  }

  mounted () {
    disableBodyScroll(this.input.$el, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el === this.input.$el) { return true }
          if (el.parentElement) { el = el.parentElement }
        }
      }
    })
    disableBodyScroll(this.historyLoader.$el, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el === this.historyLoader.$el) { return true }
          if (el.parentElement) { el = el.parentElement }
        }
      }
    })
  }

  beforeDestroy () {
    clearAllBodyScrollLocks()
  }

  async historyLoad (index: number, done: (stop?: boolean) => void) {
    await this.chat.load(done)
  }

  focus (event: FocusEvent) {
    // let el = event.relatedTarget as HTMLElement
    // while (el && el.parentElement) {
    //   if (el === this.sendButton.$el) {
    //
    //     this.input.focus()
    //     this.$nextTick(() => {
    //       this.input.focus()
    //     })
    //     window.setTimeout(() => {
    //       this.input.focus()
    //     }, 10);
    //
    //     break
    //   }
    //   el = el.parentElement
    // }
  }

  async send () {
    const message = this.message.trim()
    this.message = ''

    // this.input.focus()
    // this.$nextTick(() => {
    //   this.input.focus()
    // })
    // window.setTimeout(() => {
    //   this.input.focus()
    // }, 10);

    if (message) {
      this.bottom = true
      await this.chat.send(message)
    }
  }

  setBottom (e: IntersectionObserverEntry) {
    this.bottom = e.isIntersecting
  }

  scrollDown () {
    const { getScrollTarget, setScrollPosition } = scroll
    const target = getScrollTarget(this.scrollEnd)
    const offset = this.scrollEnd.offsetTop
    const duration = 1000
    setScrollPosition(target, offset, duration)
  }
}
